import { render, staticRenderFns } from "./TextBoxInputMethodEditor.vue?vue&type=template&id=1c1ebe12&scoped=true&"
import script from "./TextBoxInputMethodEditor.vue?vue&type=script&lang=ts&"
export * from "./TextBoxInputMethodEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1ebe12",
  null
  
)

export default component.exports